













import { createComponent } from '@vue/composition-api';
import UIButton from '@sbvr/lbe-ui/UIButton.vue';

export default createComponent({
  name: 'BaseLayout',
  components: {
    UIButton,
  },
  props: {
    homeLink: { type: Boolean }
  }
});

